import { api } from "../api/stagingApi.js";

export async function getCoworkers({ project }) {
  try {
    const response = await api.get(`/user/coworker?project=${project}`)

    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function createCoworkers({ coworkers, project }) {
  try {
    const response = await api.post(`/user/coworker`, {
      coworkers,
      project, 
    });
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function updateRoleCoworker({ project, users}) {
  try {
    const response = await api.post(`/user/coworker/role`, {
      project,
      users,
    });
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function resendEmailInvitationCoworker({ actual_user, email, project, role }) { 
  try {
    const response = await api.post(`/user/coworker/resend`, {
      actual_user,
      email,
      project,
      role,
    });
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function getUserInfo() {
  try {
    const response = await api.get(`/user/info`);
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function updateProfileImage({ image }) {
  try {
    const formData = new FormData();
    formData.append('image', image);
    const response = await api.post(`/user/image`, formData);
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}


export async function subscribeUserAction(idSession) {
  try {
    const response = await api.post(`/user/subscribe/premium`,{idSession});
    return response.data;
  } catch (error) {
    return error
  }
}

export async function saveWelcome() {
  try {
    const response = await api.post(`/user/welcome`);
    return { error: false, res: response.data }
  } catch (error) {
    return { error: true, details: error }
  }
}

export async function getReferred() {
  try {
    const response = await api.get(`/user/referred`);
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}

export async function acceptProjectInvitation(token) {
  try {
    const response = await api.post(`/user/coworker/invitation`, { token });
    return response.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      return {
        error: true,
        message: error?.response?.data?.message,
        details: error?.response?.data?.details || "",
      };
    } else {
      return {
        error: true,
        message: "An error has occurred",
        details: "",
      };
    }
  }
}
